module.exports = __webpack_public_path__ + "img/deeplink-icon.33622e13.svg";